module.exports = __webpack_public_path__ + "static/group2-e50c3ab57b9ae3bf95504563408372fb.png";